import React, { useState, useEffect } from "react";
import url from "../config/Config";
import {
    MDBNavbar,
    MDBNavbarNav,
    MDBNavItem,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBIcon,
    MDBContainer,
    MDBDropdownItem,
} from "mdbreact";
import { useHistory } from "react-router-dom";
import { Cart } from "./Cart";
import { MenuLeftSidebar } from "./MenuLeftSidebar";

const NavBarMain = () => {
    const [categorias, setCategorias] = useState([]);

    const [scrolled, setScrolled] = useState(false);
    const [modalSidebarCarrito, setModalSidebarCarrito] = useState(false);
    const [carrito, setCarrito] = useState([]);
    const [showLogin, setShowLogin] = useState(false);
    const [dataUserAutenticado, setDataUserAutenticado] = useState(null);
    
    const [modalSidebarLeft, setModalSidebarLeft] = useState( false );

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if (localStorage.getItem("CarritoJucumari")) {
            let ca = JSON.parse(localStorage.getItem("CarritoJucumari"));
            setCarrito(ca);
        }
        if (localStorage.getItem("LoginJucumari")) {
            let l = JSON.parse(localStorage.getItem("LoginJucumari"));
            if (l.length > 0) {
                setShowLogin(true);
                setDataUserAutenticado(l[0]);
            }
        } else {
            setShowLogin(false);
        }
        window.addEventListener("storage", (e) => {
            let ca = JSON.parse(localStorage.getItem("CarritoJucumari"));
            if (ca) {
                setCarrito(ca);
            }
            let l = JSON.parse(localStorage.getItem("LoginJucumari"));
            if (l) {
                setShowLogin(true);
                setDataUserAutenticado(l[0]);
            }
        });
        listaCategoria();
    }, []);

    const listaCategoria = () => {
        const datos = {
            accion: "listarCategoriaItems",
            llave: url.llavedefault,
        };
        fetch(url.service + "categoria", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                setCategorias(responseJson);
            });
    };

    const CerrarSesion = () => {
        let datos = {
            correo: url.userDefault,
            pass: url.correoDefault,
            empresa: url.empresa,
            sucursal: url.sucursal,
        };
        fetch(url.service + "loginClienteEmpresa", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                let lista = Array.from(responseJson);
                let params = {
                    e: lista[0].label.split("-")[0],
                    s: lista[0].label.split("-")[1],
                    d: "12346-7888",
                    id: lista[0].id[0].idcliente,
                };
                fetch(url.service + "jucumariCliente", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(params),
                })
                    .then((response) => response.json())
                    .then((responseJson) => {
                        //console.log(responseJson)
                        if (responseJson.llave) {
                            url.llavedefault = responseJson.llave;
                            localStorage.removeItem("LoginJucumari");
                            window.location.assign(
                                "/" +
                                    "?e=".concat(
                                        localStorage.getItem("empresa")
                                    )
                            );
                        }
                    });
            });
    };

    const history = useHistory();

    const handleClickCategoria = (item) => {
        const destino =
            `/categoria/${item.IdCategoria}/${item.Nombre}/1?e=` +
            localStorage.getItem("empresa");
        history.push(destino);
    };
    const stateModalSidebar = () => {
        setModalSidebarCarrito(!modalSidebarCarrito);
    };

    const stateModalSidebarLeft = () => {
        setModalSidebarLeft(!modalSidebarLeft);
    };

    return (
        <>
            <Cart
                modalSidebarCarrito={modalSidebarCarrito}
                setModalSidebarCarrito={stateModalSidebar}
            />
            <MenuLeftSidebar
                categorias={ categorias }
                stateModalSidebarLeft={ stateModalSidebarLeft }
                modalSidebarLeft={ modalSidebarLeft }
            />
            <div className="">
                <div className="hidden lg:block bg-[#f5f5f5] py-2 ">
                    <div className="max-w-7xl mx-auto flex items-center text-sm px-4">
                        <div className="flex items-center justify-between w-full gap-3 text-[#6b306e]">
                            <a href="https://www.facebook.com/marcasestrellas" target="_blank" rel="noopener" >
                                <i className="fab fa-facebook-f text-xl"></i>
                            </a>
                            <span className="flex items-center gap-2">
                                <a target="_blank" rel="noopener" href={`https://api.whatsapp.com/send?phone=59175095058&text=Más información de los productos`}>
                                    <i className="fab fa-whatsapp text-xl"></i>
                                    ¿Necesitas ayuda?
                                </a>
                            </span>
                        </div>
                    </div>
                </div>

              

                <div
                    className={`bg-secondary-personalize fixed w-full z-50 transition-all duration-50 ${
                        scrolled ? "lg:top-0" : "lg:top-10"
                    }`}
                >
                    <nav className="px-2 lg:px-0 lg:max-w-7xl mx-auto py-1">
                        <div className="grid grid-cols-2 lg:flex lg:flex-wrap justify-between items-center">
                            <div className="flex items-center gap-1">
                                <button
                                    className="lg:hidden"
                                    type="button"
                                    onClick={ () => stateModalSidebarLeft() }
                                >
                                    <i className="fas fa-bars"></i>
                                </button>
                                <div className="w-32 lg:w-60 h-8 lg:h-16 overflow-hidden relative">
                                    <a
                                        href={
                                            "/" +
                                            "?e=".concat(
                                                localStorage.getItem("empresa")
                                            )
                                        }
                                    >
                                        <img
                                            src="/img/logo-fondo.png"
                                            alt="Logo"
                                            className="absolute top-3 lg:top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                        />
                                    </a>
                                </div>
                            </div>
                            <form className="hidden lg:block flex-1 max-w-md">
                                <div className="relative">
                                    <input
                                        type="text"
                                        className="w-full border-2 border-[#6b306e] rounded-full py-2 pr-10 pl-4 bg-transparent text-white placeholder:text-gray-900 placeholder:font-semibold focus:bg-transparent  focus:outline-none"
                                        placeholder="Buscar artículos"
                                    />
                                    <i className="fas fa-search absolute right-3 top-1/2 -translate-y-1/2 text-tertiary-personalize"></i>
                                </div>
                            </form>

                         

                            <div className="flex  items-center justify-end gap-3 text-tertiary-personalize">
                                <div className="flex items-center gap-2">
                                    <span className="lg:hidden">
                                        <i className="fab fa-whatsapp text-xl"></i>
                                    </span>
                                    <span className="lg:hidden">{" | "}</span>
                                    <i
                                        className="fas fa-shopping-cart cursor-pointer"
                                        onClick={() => {
                                            stateModalSidebar();
                                        }}
                                    ></i>
                                    <span className="h-6 w-6 flex justify-center items-center rounded-md bg-white text-black text-sm font-bold">
                                        {carrito.length}
                                    </span>
                                </div>
                                <span>{" | "}</span>

                                {showLogin ? (
                                    <MDBNavbarNav className="override-navbar-width ">
                                        <MDBNavItem className="">
                                            <MDBDropdown>
                                                <MDBDropdownToggle
                                                    nav
                                                    caret
                                                    className="hover:text-tertiary-personalize/60"
                                                >
                                                    <MDBIcon icon="user" />{" "}
                                                    <strong className="black-text ">
                                                        Perfil
                                                    </strong>
                                                </MDBDropdownToggle>
                                                <MDBDropdownMenu
                                                    className="dropdown p-0 space-x-16"
                                                    style={{ width: "250px" }}
                                                    right
                                                >
                                                    <div className="dropdown-header w-full bg-tertiary-personalize text-white font-bold">
                                                        Datos de Usuario
                                                    </div>
                                                    <hr></hr>
                                                    <MDBDropdownItem
                                                        className="dropdown-item dropdwon-menu-nav"
                                                        
                                                        onClick={() => {
                                                            history.push(
                                                                "/Perfil" +
                                                                    "?e=".concat(
                                                                        localStorage.getItem(
                                                                            "empresa"
                                                                        )
                                                                    )
                                                            );
                                                        }}
                                                    >
                                                        {" "}
                                                        <MDBIcon
                                                            icon="user"
                                                            style={{
                                                                height: "40px",
                                                                lineHeight:
                                                                    "40px",
                                                            }}
                                                            className="pl1 hover:bg-red-400"
                                                        />{" "}
                                                        {
                                                            dataUserAutenticado.nombre
                                                        }
                                                    </MDBDropdownItem>
                                                    <MDBDropdownItem
                                                        className="dropdown-item dropdwon-menu-nav"
                                                        onClick={() =>
                                                            CerrarSesion()
                                                        }
                                                    >
                                                        {" "}
                                                        <MDBIcon icon="sign-out-alt" />{" "}
                                                        Cerrar Sesion
                                                    </MDBDropdownItem>
                                                    <MDBDropdownItem
                                                        className="dropdown-item dropdwon-menu-nav"
                                                        onClick={() => {
                                                            history.push(
                                                                "/Pedido" +
                                                                    "?e=".concat(
                                                                        localStorage.getItem(
                                                                            "empresa"
                                                                        )
                                                                    )
                                                            );
                                                        }}
                                                    >
                                                        {" "}
                                                        <MDBIcon icon="shopping-cart" />{" "}
                                                        Mis Pedidos
                                                    </MDBDropdownItem>

                                                    <hr></hr>
                                                    <h1 className="dropdown-header">
                                                        Datos de la Empresa
                                                    </h1>
                                                    <hr></hr>
                                                    <MDBDropdownItem
                                                        className="dropdown-item dropdwon-menu-nav"
                                                        onClick={() => {
                                                            history.push(
                                                                "/PerfilEmpresa" +
                                                                    "?e=".concat(
                                                                        localStorage.getItem(
                                                                            "empresa"
                                                                        )
                                                                    )
                                                            );
                                                        }}
                                                    >
                                                        <MDBIcon icon="home" />{" "}
                                                        Perfil Empresa
                                                    </MDBDropdownItem>
                                                    <MDBDropdownItem
                                                        className="dropdown-item dropdwon-menu-nav"
                                                        onClick={() => {
                                                            history.push(
                                                                "/Contacto" +
                                                                    "?e=".concat(
                                                                        localStorage.getItem(
                                                                            "empresa"
                                                                        )
                                                                    )
                                                            );
                                                        }}
                                                    >
                                                        <MDBIcon icon="info-circle" />{" "}
                                                        Sugerencias
                                                    </MDBDropdownItem>

                                                    <hr></hr>
                                                    <h1 className="dropdown-header">
                                                        Acerca de Nosotros
                                                    </h1>
                                                    <hr></hr>
                                                    <MDBDropdownItem
                                                        className="dropdown-item dropdwon-menu-nav"
                                                        // onClick={this.toggle(5)}
                                                    >
                                                        <MDBIcon icon="question-circle" />{" "}
                                                        Nosotros
                                                    </MDBDropdownItem>
                                                </MDBDropdownMenu>
                                            </MDBDropdown>
                                        </MDBNavItem>
                                    </MDBNavbarNav>
                                ) : (
                                    <>
                                        <i className="fas fa-user"></i>
                                        <span
                                            className="text-[10px] lg:text-base font-bold cursor-pointer"
                                            onClick={() => {
                                                history.push(
                                                    "/Login" +
                                                        "?e=".concat(
                                                            localStorage.getItem(
                                                                "empresa"
                                                            )
                                                        )
                                                );
                                            }}
                                        >
                                            Iniciar Sesión
                                        </span>
                                    </>
                                )}
                                {/* <span className="font-bold">Registro</span> */}
                            </div>
                        </div>
                    </nav>
                    {/* Categorias */}
                    <div className="hidden lg:block bg-tertiary-personalize">
                        <div className="max-w-7xl mx-auto flex items-center gap-6 px-2">
                            <MDBDropdown className="w-[30%]">
                                <MDBDropdownToggle
                                    nav
                                    caret
                                    className="text-white font-bold "
                                >
                                    <MDBIcon fas icon="bars" /> Categorías
                                </MDBDropdownToggle>
                                <MDBDropdownMenu className="p-3 w-80">
                                    {categorias.map((item) => (
                                        <a
                                            key={item.IdCategoria}
                                            href={
                                                `/categoria/${item.IdCategoria}/${item.Nombre}/1?e=` +
                                                localStorage.getItem("empresa")
                                            }
                                            className="flex items-center gap-2 cursor-pointer hover:bg-tertiary-personalize hover:text-white hover:no-underline p-1 rounded-md"
                                        >
                                            <img
                                                src={item.Imagen.replace(
                                                    "/var/www/html",
                                                    url.serviceImg
                                                )}
                                                alt=""
                                                className="w-10 h-10 object-cover rounded"
                                            />
                                            <span className="text-sm font-medium">
                                                {url.capitalizeWords(
                                                    item.Nombre
                                                )}
                                            </span>
                                        </a>
                                    ))}
                                </MDBDropdownMenu>
                            </MDBDropdown>
                            <div className="flex items-center justify-between gap-2 flex-wrap w-full">
                                {categorias.slice(0, 5).map((item) => (
                                    <a
                                        href={
                                            `/categoria/${item.IdCategoria}/${item.Nombre}/1?e=` +
                                            localStorage.getItem("empresa")
                                        }
                                        key={item.IdCategoria}
                                        className="text-white py-3 px-4 font-bold text-sm block hover:bg-purple-300/10 z-10 hover:no-underline"
                                    >
                                        {url.capitalizeWords(item.Nombre)}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

            <div className="h-[60px] lg:block lg:h-[110px]"></div>
            </div>
        </>
    );
};

export default NavBarMain;
